import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  container: {
    padding: 70,
    ["@media (max-width:1200px)"]: {
      padding: 40,
    },
    ["@media (max-width:959px)"]: {
      padding: 20,
    },
    ["@media (max-width:559px)"]: {
      padding: 5,
      paddingTop: 20,
    },
  },
});
